import React from 'react';
import './EagleSpinner.css';
// Zaimportuj swoje logo. Upewnij się, że ścieżka jest poprawna!
import eagleLogo  from '../../img/logo_full.png';

const EagleSpinner = () => {
  return (
    <div className="eagle-spinner-container">
      <img 
        src={eagleLogo} 
        alt="Ładowanie..." 
        className="eagle-spinner-logo" 
      />
    </div>
  );
};

export default EagleSpinner;